<template>
  <echarts :options="options" class="chart-stage"></echarts>
</template>
<script>
import echarts from "./basic";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

export default {
  props: {
    category: {
      type: Array,
    },
    area: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      required: true
    },
    grid: {
      type: Object,
      default() {
        return {}
      }
    },
    unit: {
      type: String,
      default: ''
    },
    unitX: {
      type: String,
      default: ''
    },
    parmasId:{
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 注：legend(线)使用rgba会出现悬浮时图例消失的情况
      // 发电rgb(216, 24, 59)、用电-负载rgb(255, 108, 26)、买电-电网rgb(218, 222, 39)、
      // 卖电rgb(141, 222, 38)、充电-电池rgb(31, 206, 164)、放电rgb(33, 156, 225)
      // lineColor: [
      //   'rgb(216, 24, 59, 1)', 'rgb(255, 108, 26, 1)', 
      //   'rgb(218, 222, 39, 1)','rgb(141, 222, 38, 1)',
      //   'rgb(31, 206, 164, 1)', 'rgb(33, 156, 225, 1)'
      // ],
      areaColor: [
        this.parmasId==true?'rgb(216, 24, 59, 0.15)':'rgb(255, 127, 80, 0.15)', this.parmasId==true?'rgb(66, 187, 225, 0.15)':'rgb(216, 24, 59, 0.15)', 
        'rgb(251, 255, 46, 0.15)','rgb(78, 255, 63, 0.15)',
        'rgb(46, 255, 205, 0.15)', 'rgb(66, 187, 225, 0.15)'
      ],
      lineColor: [
        this.parmasId==true?'#d8183b':'#FF7F50',this.parmasId==true?'#42BBFF':'#d8183b',  
        '#FBFF2E','#4EFF3F',
        '#2EFFCD', '#42BBFF'
      ],
      // areaColor: [
      //   '#f7d0d7', '#ff1a43ff', 
      //   '#f7f8d3','#e8f8d3',
      //   '#d2f5ec', '#d2ebf9'
      // ],
      // 十六进制颜色
      // lineColor: ['#ff7c79', '#f19149', '#22ac38','#00a0e9'],
      // areaColor: ['#fed9d8', '#fbdfca', '#bde7c4','#bde7f9']
    }
  },
  computed: {
    options() {
      let series = [], legends = []
      this.data.forEach((ele, index) => {
        let serieData = []
        legends.push(ele.name)
        ele.value.forEach((item, i) => {
          // 接收的category
          serieData.push([this.category[i], item])
        })
        series.push({
          name: ele.name,
          type: 'line',
          smooth: false,
          symbol: 'none',
          // areaStyle: {
          //   color: this.area ? this.areaColor[index] : 'transparent'
          // },
          data: serieData
        })
      })
      let grid = {
        ...{
          top: "45",
          left: "8%",
          right: "8%",
          // ===
          bottom: "80"
        }, ...this.grid
      }
      return {
        color: this.lineColor,
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgb(51, 255, 182)",
          borderColor: "rgb(51, 255, 182)",
          borderWidth: "1",
          textStyle: {
            color: 'rgb(34, 45, 53)',
            fontSize: 12
          },
          axisPointer: {
            type: "line",
            // Old
            // label: {
            //   show: false,
            //   backgroundColor: "#6a7985"
            // },
            // New
            label: {
              formatter: function (params) {
                if (params.seriesData.length === 0) {
                  window.mouseCurValue = params.value;
                }
              }
            },
            // formatter: function (params) {
            //   let res = "", sum = 0;
            //   for (let i = 0; i < params.length; i++) {
            //       let series = params[i];
            //       sum += Number(series.data);
            //       if (sum >= window.mouseCurValue) {
            //           res = series.axisValue + "<br/>" + series.marker + series.seriesName + ":" + series.data + "<br/>";
            //           break;
            //       }
            //   }
            //   return res;
            // },
          },
          formatter:function (params) {
            let tooltipItems = '';
            let tooltipHead = '' + '<br/>';
            for (let index in params) {
              tooltipHead = params[index].value[0].slice(0,16) + '<br/>';
              // marker + color
              if (params[index].value[1]=="NaN") {
                tooltipItems += "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:" + 
                params[index].color+"'></span>" + 
                params[index].seriesName + 
                "：" + 
                "--" + 
                '<br>';
              }else{
                tooltipItems += "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:" + 
                params[index].color+"'></span>" + 
                params[index].seriesName + 
                "：" + 
                params[index].value[1] + 
                '<br>';
              }
            }
            return tooltipHead + tooltipItems;
          },
          borderRadius: 10,
          // 提示框位置
          position: function (pt) {
            return [pt[0]-50, 15];
          }
        },
        legend: {
          // ===
          icon: 'roundRect',
          bottom: '15',
          data: legends,
          selectedMode: 'multiple',
          textStyle: {
            color: '#ffffff'
          },
          // 图例关闭时颜色
          inactiveColor: "#7b8395",
        },
        grid,
        xAxis: [
          {
            type: 'time',
            name: this.unitX,
            axisLine: {
              lineStyle: {
                color: 'rgba(123, 131, 149, 1)',
                type: 'dashed',
              },
              onZero:false
            },
            axisLabel: {
              color: 'rgba(235, 235, 235, 1)',
              formatter: (value) => {
                return this.$filter.formatDate(new Date(value), 'hh')
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(123, 131, 149, 1)'
              }
            },
            splitNumber: 24,
            max: (value) => {
              return new Date(this.$filter.formatDate(new Date(value.max), 'yyyy-MM-dd') + ' 24:00:00').getTime()
            },
            min: (value) => {
              return new Date(this.$filter.formatDate(new Date(value.min), 'yyyy-MM-dd') + ' 00:00:00').getTime()
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: 'rgb(51, 255, 182)',
                width: 3,
              }
            },
            axisTick: {
              show: false,
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: this.unit,
            axisLine: {
              lineStyle: {
                color: 'rgba(123, 131, 149, 1)',
                type: 'dashed',
              }
            },
            axisLabel: {
              color: 'rgba(235, 235, 235, 1)'
            },
            axisPointer: {
              show: false,
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(123, 131, 149, 1)'
              }
            }
          }
        ],
        series
      }
    }
  },
  components: {
    echarts
  }
};
</script>
<style lang="less" scoped>
.chart-stage {
  height: 100%;
}
</style>